import React, { useCallback, useEffect, useState } from 'react';
import { CirculoCarregando, CirculoCarregandoDiv, Container } from './styles';

import api from '../../services/api';

import Dialog from '../../components/dialog';
import { CardGerencial } from '../../components/cardGerencial';
import { FechamentoCategoria } from '../Relatorios/FechamentoCategoria';

import { downloadReport } from '../../utils/downloadReport';
import { useToast } from '../../context/ToastContext';
import { ConfiguracoesPacientes } from '../Relatorios/ConfiguracoesPacientes';
import { useIndexedDB } from '../../context/IndexedDBContext';
import { useAuth } from '../../context/AuthContext';
import { downloadExcel } from '../../utils/downloadExcel';

const PainelGerencial: React.FC = () => {
  const { addToast } = useToast();
  const { gravarIndexedDB, lerIndexedDB } = useIndexedDB();
  const { user, verifyAccess } = useAuth();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isConfigPacientesOpen, setConfigPacientesOpen] = useState(false);

  const [camposSelecionados, setCamposSelecionados] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const handleDownloadExcelPacientes = useCallback(async () => {
    setLoading(true);

    const response = await api.get('/pacientes/relatorio');

    const baixou = await downloadExcel({
      dados: {
        pacientes: response.data,
      },
      reportName: `Pacientes${new Date().getTime()}`,
      template: '/clinica/ListagemPacientesExcel/ListagemPacientesExcel',
    });

    if (!baixou) {
      addToast({
        title: 'Falha no Download',
        description: 'Não foi possível concluir o download',
        type: 'error',
      });

      setLoading(false);
      return false;
    }

    setLoading(false);
    return true;
  }, [addToast]);

  const handleDownloadReportPacientes = useCallback(async () => {
    setLoading(true);

    const response = await api.get('/pacientes/relatorio');

    const baixou = await downloadReport({
      dados: {
        pacientes: response.data,
        resumido: !verifyAccess('VISUALIZAR CAMPOS DO RELATÓRIO DE PACIENTES'),
        camposSelecionados,
      },
      reportName: `Pacientes${new Date().getTime()}`,
      template: '/clinica/ListagemPacientes/pacientes-main',
    });

    if (!baixou) {
      addToast({
        title: 'Falha no Download',
        description: 'Não foi possível concluir o download',
        type: 'error',
      });
    }

    setLoading(false);
  }, [addToast, camposSelecionados, verifyAccess]);

  useEffect(() => {
    async function carregarCampos() {
      const dados = await lerIndexedDB(
        `${user.empresa.url_frontend}-${user.id}:campos-pacientes`,
      );

      if (dados) {
        try {
          if (typeof dados === 'string') {
            const parsed: string[] = JSON.parse(dados);
            setCamposSelecionados(parsed);
          }
        } catch (err) {
          console.error('Erro ao fazer parse do IndexedDB', err);
        }
      }
    }

    carregarCampos();
  }, [user, lerIndexedDB, setCamposSelecionados]);

  return loading ? (
    <CirculoCarregandoDiv>
      <CirculoCarregando />
    </CirculoCarregandoDiv>
  ) : (
    <Container>
      <CardGerencial
        description="Lista de todos os pacientes cadastrados no sistema"
        title="Listagem de Pacientes"
        variant="report"
        showSettings={true}
        onHeaderIconClick={handleDownloadReportPacientes}
        onSettingsIconClick={() => setConfigPacientesOpen(true)}
        onExcelIconClick={handleDownloadExcelPacientes}
      />

      <CardGerencial
        description="Custo e preço dos agendamentos por profissional e categoria"
        title="Fechamento por Profissional"
        variant="report"
        showSettings={false}
        onHeaderIconClick={() => setDialogOpen(true)}
      />

      <Dialog isOpen={isDialogOpen} onClose={() => setDialogOpen(false)}>
        <FechamentoCategoria />
      </Dialog>

      <Dialog
        isOpen={isConfigPacientesOpen}
        onClose={() => {
          setConfigPacientesOpen(false);
          gravarIndexedDB(
            `${user.empresa.url_frontend}-${user.id}:campos-pacientes`,
            `${JSON.stringify(camposSelecionados)}`,
          );
        }}
      >
        <ConfiguracoesPacientes
          camposSelecionados={camposSelecionados}
          setCamposSelecionados={setCamposSelecionados}
        />
      </Dialog>
    </Container>
  );
};

export default PainelGerencial;
